<template>
  <li class="options-item" :class="{'parent-without-footer': !parentHasFooter}">
    <div class="item-text">
      <slot name="description"></slot>
    </div>
    <div class="item-actions" v-if="$slots.actions">
      <slot name="actions"></slot>
    </div>
  </li>
</template>

<script>
export default {
  name: 'options-item',
  computed: {
    parentHasFooter () {
      return this.$parent.$slots.footer
    }
  }
}
</script>

<style scoped lang="scss">
.options-item {
  padding: 1.6rem 0;
  border-bottom: 1px solid $grey;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .item-text {
    flex: 1 1 auto;
  }

  .item-actions {
    padding-left: 1rem;
  }

  &.parent-without-footer:last-child {
    border-bottom: none;
  }
}
</style>
